import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type OptionButtonProps = {
  number: number;
  meaning: string;
  isSelected: boolean;
  isDisabled: boolean;
  onClick: () => void;
};

export function OptionButton({ number, meaning, isSelected, isDisabled, onClick }: OptionButtonProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="lg"
      onClick={onClick}
      disabled={isDisabled}
      className={cn(
        "w-full flex items-center gap-3 rounded-xl border-2 bg-card hover:bg-card py-4 px-3.5 h-auto whitespace-normal transition-colors opacity-100! break-keep",
        isDisabled && !isSelected && "cursor-default",
        isSelected ? "border-primary bg-card" : "hover:border-primary/20",
      )}
    >
      {/* 옵션 번호 */}
      <span
        className={cn(
          "shrink-0 size-10 rounded-lg text-base font-bold flex items-center justify-center transition-colors",
          isSelected ? "bg-primary text-primary-foreground" : "bg-primary/10 text-primary",
        )}
      >
        {number}
      </span>

      {/* 옵션 텍스트 */}
      <span
        className={cn(
          "flex-1 text-center text-lg font-semibold",
          isSelected ? "font-bold text-slate-800" : "text-slate-700",
        )}
      >
        {meaning}
      </span>
    </Button>
  );
}
